
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AggregationResource,
  ClientProjectsManagementSearchResultResource,
  ContractType,
  OpportunityType,
  ProjectClientAction,
  ProjectStatus,
  RenewalStatus,
  SortOrder,
  SortType,
  ValidationError,
  VerticalType,
} from '../models';
import {
    AggregationResourceFromJSON,
    AggregationResourceToJSON,
    ClientProjectsManagementSearchResultResourceFromJSON,
    ClientProjectsManagementSearchResultResourceToJSON,
    ContractTypeFromJSON,
    ContractTypeToJSON,
    OpportunityTypeFromJSON,
    OpportunityTypeToJSON,
    ProjectClientActionFromJSON,
    ProjectClientActionToJSON,
    ProjectStatusFromJSON,
    ProjectStatusToJSON,
    RenewalStatusFromJSON,
    RenewalStatusToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    SortTypeFromJSON,
    SortTypeToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
    VerticalTypeFromJSON,
    VerticalTypeToJSON,
} from '../models';

export interface FilterAggregateRequest {
    aggregateName: string;
    aggregateFilter?: string;
    query?: string;
    owners?: Array<string>;
    companies?: Array<string>;
    organizations?: Array<string>;
    actions?: Array<ProjectClientAction>;
    status?: Array<ProjectStatus>;
    freelancers?: Array<string>;
    companyManagers?: Array<string>;
    finOpsManagers?: Array<string>;
    customerSuccessManagers?: Array<string>;
    contractTypes?: Array<ContractType>;
    verticalTypes?: Array<VerticalType>;
    opportunityTypes?: Array<OpportunityType>;
    renewalStatuses?: Array<RenewalStatus>;
    startDateFrom?: Date;
    startDateTo?: Date;
    endDateFrom?: Date;
    endDateTo?: Date;
}

export interface SearchRequest {
    query?: string;
    owners?: Array<string>;
    companies?: Array<string>;
    organizations?: Array<string>;
    actions?: Array<ProjectClientAction>;
    status?: Array<ProjectStatus>;
    freelancers?: Array<string>;
    companyManagers?: Array<string>;
    finOpsManagers?: Array<string>;
    customerSuccessManagers?: Array<string>;
    contractTypes?: Array<ContractType>;
    verticalTypes?: Array<VerticalType>;
    opportunityTypes?: Array<OpportunityType>;
    renewalStatuses?: Array<RenewalStatus>;
    startDateFrom?: Date;
    startDateTo?: Date;
    endDateFrom?: Date;
    endDateTo?: Date;
    sortBy?: SortType;
    sortOrder?: SortOrder;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class ProjectClientListApi extends runtime.BaseAPI {

    /**
          */
    async filterAggregateRaw(requestParameters: FilterAggregateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<{ [key: string]: Array<AggregationResource>; }>> {
        if (requestParameters['aggregateName'] == null) {
            throw new runtime.RequiredError(
                'aggregateName',
                'Required parameter "aggregateName" was null or undefined when calling filterAggregate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aggregateFilter'] != null) {
            queryParameters['aggregateFilter'] = requestParameters['aggregateFilter'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['owners'] != null) {
            queryParameters['owners'] = requestParameters['owners']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companies'] != null) {
            queryParameters['companies'] = requestParameters['companies']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['organizations'] != null) {
            queryParameters['organizations'] = requestParameters['organizations']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['actions'] != null) {
            queryParameters['actions'] = requestParameters['actions']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['freelancers'] != null) {
            queryParameters['freelancers'] = requestParameters['freelancers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companyManagers'] != null) {
            queryParameters['companyManagers'] = requestParameters['companyManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['finOpsManagers'] != null) {
            queryParameters['finOpsManagers'] = requestParameters['finOpsManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['customerSuccessManagers'] != null) {
            queryParameters['customerSuccessManagers'] = requestParameters['customerSuccessManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['contractTypes'] != null) {
            queryParameters['contractTypes'] = requestParameters['contractTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['verticalTypes'] != null) {
            queryParameters['verticalTypes'] = requestParameters['verticalTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['opportunityTypes'] != null) {
            queryParameters['opportunityTypes'] = requestParameters['opportunityTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['renewalStatuses'] != null) {
            queryParameters['renewalStatuses'] = requestParameters['renewalStatuses']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = (requestParameters['startDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = (requestParameters['startDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = (requestParameters['endDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = (requestParameters['endDateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<{ [key: string]: Array<AggregationResource>; }>({
            path: `/project-client/api/aggregate/{aggregateName}`.replace(`{${"aggregateName"}}`, encodeURIComponent(String(requestParameters['aggregateName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async filterAggregate(requestParameters: FilterAggregateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<AggregationResource>; }> {
        const response = await this.filterAggregateRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientProjectsManagementSearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['owners'] != null) {
            queryParameters['owners'] = requestParameters['owners']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companies'] != null) {
            queryParameters['companies'] = requestParameters['companies']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['organizations'] != null) {
            queryParameters['organizations'] = requestParameters['organizations']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['actions'] != null) {
            queryParameters['actions'] = requestParameters['actions']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['freelancers'] != null) {
            queryParameters['freelancers'] = requestParameters['freelancers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companyManagers'] != null) {
            queryParameters['companyManagers'] = requestParameters['companyManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['finOpsManagers'] != null) {
            queryParameters['finOpsManagers'] = requestParameters['finOpsManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['customerSuccessManagers'] != null) {
            queryParameters['customerSuccessManagers'] = requestParameters['customerSuccessManagers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['contractTypes'] != null) {
            queryParameters['contractTypes'] = requestParameters['contractTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['verticalTypes'] != null) {
            queryParameters['verticalTypes'] = requestParameters['verticalTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['opportunityTypes'] != null) {
            queryParameters['opportunityTypes'] = requestParameters['opportunityTypes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['renewalStatuses'] != null) {
            queryParameters['renewalStatuses'] = requestParameters['renewalStatuses']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = (requestParameters['startDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = (requestParameters['startDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = (requestParameters['endDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = (requestParameters['endDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientProjectsManagementSearchResultResource>({
            path: `/project-client/api/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientProjectsManagementSearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async search(requestParameters: SearchRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientProjectsManagementSearchResultResource> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return response._data;
    }

}
